// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent-element[data-v-2b67acca] {\n  position: absolute !important;\n  top: calc(50px + var(--pos-top));\n  height: calc(var(--height) - 1px);\n  min-height: 20px;\n  left: 2px;\n  padding: 1px;\n  border: 1px solid #3291ef;\n  border-radius: 5px;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
